import styled from 'styled-components';
import type { FlattenSimpleInterpolation } from 'styled-components';

interface StyledBoxProps {
    $layoutCss?: Array<FlattenSimpleInterpolation | string>;
}

export const StyledBox = styled.div<StyledBoxProps>`
    box-sizing: border-box;
    ${({ $layoutCss }) => $layoutCss}
`;
